<div *ngIf="loaded">
  <div class="bff-form-row mb-3">
    <div class="bff-form-group bff-text" [innerHTML]="'param.modal.version.paypal-infos-essentiel' | translate"></div>
  </div>
  <!-- PayPal button -->
  <div class="bff-button-container bff-button-container--center">
    <button type="button" class="bff-button bff-button--primary bff-button--full-mobile" (click)="subscribe()">
      <img src="https://www.paypalobjects.com/fr_FR/FR/i/btn/btn_subscribeCC_LG.gif"
           alt="PayPal, le réflexe sécurité pour payer en ligne"
           style="height: 32px; vertical-align: middle; margin-right: 8px;">
      S'abonner Essentiel
    </button>
    <div><br/></div>
  </div>
</div>
<div *ngIf="!loaded" class="bff-loading-overlay">
  <img src="/assets/images/loader.gif" alt="loading" class="bff-loading-icon" />
</div>



